<template>
    <layout>
        <div class="admin-layout">
            <AdminSidebar />

            <div class="admin-content">
                <router-view />
            </div>
        </div>
    </layout>
</template>

<script>
import Layout from "@/components/layouts/Layout";
import AdminSidebar from "@/components/admin/AdminSidebar.vue";

export default {
    name: "Admin",
    components: { Layout, AdminSidebar }
};
</script>

<style>
.admin-layout {
    display: flex;
    min-height: 100vh;
}

.admin-content {
    margin-left: 220px;
    padding: 40px;
    width: 100%;
}
</style>